export default __webpack_public_path__ + "static/media/home.bdd4f32f.png";